import { NgModule } from '@angular/core';
import { SharedModule } from './../../../shared/modules/shared.module'
import { RouterModule }  from '@angular/router';
import { CredentialVerificationComponent } from './credential-verification.component';
import { StateLicensureComponent } from './state-licensure/state-licensure.component';
import { SelfComponent } from './self/self.component';
import { ThirdPartyComponent } from './third-party/third-party.component';
import { EmailComponent } from './email/email.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxMaskModule
  ],
  declarations: [
    CredentialVerificationComponent, 
    StateLicensureComponent, 
    SelfComponent, 
    ThirdPartyComponent,
    EmailComponent
  ]
})
export class CredentialVerificationModule { }
